export const supportConstants = {
    FETCH_SUBJECTS: 'SUPPORT_FETCH_SUBJECTS',
    FETCH_SUBJECTS_REQUEST: 'FETCH_SUBJECTS_REQUEST',
    SUPPORT_SAVE: 'SUPPORT_SAVE'
};
